import { useMemo } from "react";
import useSWR from "swr";
import fetcher from "./fetcher";
import { toDomainService } from "../domain/influencerService";

export default function useAvailableServicesForProduct(productId) {
  const { data, error, mutate } = useSWR(
    productId ? `/api/product/${productId}/services` : null,
    fetcher,
  );

  const services = useMemo(
    () => (data?.services ?? []).map(toDomainService),
    [data],
  );

  return {
    services,
    isLoading: !data && !error && productId != null,
    isError: Boolean(error),
    error,
    refresh: mutate,
  };
}
